import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";
import { TUserReferralCodeUsageData } from "../../Types";

export const apiCallGetUserReferralCodeUsageData = async ({
  condition,
  value,
  limit
}: {
  condition: string;
  value: string;
  limit: number;
}): Promise<{
  data: TUserReferralCodeUsageData[];
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<TUserReferralCodeUsageData[]>(
    `user/getUserReferralCodeUsageData`,
    {
      condition,
      value,
      limit
    }
  );

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: [
        {
          createdOn: "",
          peerId: 0,
          ownerPlatform: "",
          referralCode: "",
          ownerReward: "",
          codeValidityOrReason: "",
          userId: 0,
          userPlatform: "",
          userReward: ""
        }
      ],
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: [
        {
          createdOn: "",
          peerId: 0,
          ownerPlatform: "",
          referralCode: "",
          ownerReward: "",
          codeValidityOrReason: "",
          userId: 0,
          userPlatform: "",
          userReward: ""
        }
      ],
      status: "ERROR",
      code: "ERROR"
    };
  }
};
